/**
 * Sport watermpark image types.
 *
 * @class SportWatermarkImageTypes
 * @memberof Mojito.Presentation.Components
 */
export default class SportWatermarkImageTypes {}

/**
 * The Sport Watermark Image positions.
 *
 * @enum {string}
 * @memberof Mojito.Presentation.Components.SportWatermarkImageTypes
 */
SportWatermarkImageTypes.POSITIONS = {
    TOP_LEFT: 'topLeft',
    TOP_RIGHT: 'topRight',
    BOTTOM_LEFT: 'bottomLeft',
    BOTTOM_RIGHT: 'bottomRight',
};
